if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            // 23-sep-2026: guard — si no hay miniatura no se revienta el flujo de variante.
            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
                activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // 23-sep-2026 (Claude, a pedido de Roberto): las miniaturas de otros colores ya no
      // vienen en el HTML inicial, asi que al cambiar de variante product-info.js pasa la
      // lista de miniaturas de la seccion recien pedida y aqui se reemplaza y se vuelven a
      // enganchar los clicks. Sin esto, al cambiar de color quedarian las miniaturas viejas.
      refreshThumbnails(newList) {
        if (!this.elements.thumbnails || !newList) return;
        const list = this.elements.thumbnails.querySelector('ul');
        if (!list) return;
        list.innerHTML = newList.innerHTML;
        // FIX 23-sep-2026: en el modal quick-add ("Seleccionar opciones" en mobile y en
        // colecciones) los ids llevan el prefijo "quickadd-" (data-section) pero la seccion
        // que se pide al cambiar de variante es la original (data-original-section). Sin
        // esta reescritura setActiveMedia no encontraba la miniatura nueva y reventaba,
        // dejando el boton "Agregar al carrito" deshabilitado.
        const productInfo = this.closest('product-info');
        const sectionId = productInfo?.dataset.section;
        const originalSection = productInfo?.dataset.originalSection;
        if (sectionId && originalSection && originalSection !== sectionId) {
          const fix = (value) => (value ? value.split(originalSection).join(sectionId) : value);
          list.querySelectorAll('[data-target]').forEach((el) => (el.dataset.target = fix(el.dataset.target)));
          list.querySelectorAll('[id]').forEach((el) => (el.id = fix(el.id)));
          list
            .querySelectorAll('[aria-describedby]')
            .forEach((el) => el.setAttribute('aria-describedby', fix(el.getAttribute('aria-describedby'))));
          // Las fotos nuevas de la lista principal (las inserta updateMedia desde el mismo HTML) traen el mismo problema.
          this.elements.viewer?.querySelectorAll('[data-media-id]').forEach((el) => {
            el.dataset.mediaId = fix(el.dataset.mediaId);
            if (el.id) el.id = fix(el.id);
          });
        }
        list.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (typeof this.elements.thumbnails.resetPages === 'function') this.elements.thumbnails.resetPages();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

function actualizarDotsNavegacion() {
  if (!window.location.pathname.includes('/products')) return;

  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;
  const slidesVisibles = mediaGallery.querySelectorAll('.product__media-item:not(.hide-image)');
  const totalSlides = slidesVisibles.length;

  const dotsContainer = mediaGallery.querySelector('.slideshow__control-wrapper');
  if (!dotsContainer) return;
  const dots = dotsContainer.querySelectorAll('.slider-counter__link');

  dots.forEach((dot) => {
    dot.style.display = 'none';
  });
  slidesVisibles.forEach((slide, index) => {
    if (index < dots.length) {
      dots[index].style.display = '';
    }
  });

  const totalCounter = mediaGallery.querySelector('.slider-counter--total');
  if (totalCounter) {
    totalCounter.textContent = totalSlides.toString();
  }
  restaurarNavegacion(mediaGallery);
}

function restaurarNavegacion(mediaGallery) {
  if (!mediaGallery) return;
  const sliderViewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
  if (!sliderViewer || !sliderViewer.slider) return;

  if (typeof sliderViewer.resetPages === 'function') {
    sliderViewer.resetPages();
  }
  const activeSlide = mediaGallery.querySelector('.product__media-item.is-active:not(.hide-image)');
  const visibleSlides = mediaGallery.querySelectorAll('.product__media-item:not(.hide-image)');

  if (!activeSlide && visibleSlides.length > 0) {
    visibleSlides[0].classList.add('is-active');

    if (sliderViewer.slider) {
      sliderViewer.scrollTo({
        left: visibleSlides[0].offsetLeft,
      });
    }
  }
}

document.addEventListener('variant:change', function () {
  setTimeout(actualizarDotsNavegacion, 150);
  setTimeout(actualizarDotsNavegacion, 500);
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(actualizarDotsNavegacion, 300);
});

document.addEventListener('click', function (event) {
  if (
    window.location.pathname.includes('/products') &&
    (event.target.closest('.slider-button--prev') || event.target.closest('.slider-button--next'))
  ) {
    setTimeout(restaurarNavegacion, 50, document.querySelector('media-gallery'));
  }
});
